export default "__VITE_ASSET__dfc071b0__"